import React from 'react';
import SocialProfilesBasicInfoComponent from './social-profiles-basic-info.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';

function SocialProfilesComponent({ handleInnerFormChange, back, handleFormSubmit, selectedSocialProfiles, socialProfileType }: any) {
    const tabItems = [
        {
            id: 1,
            title: 'Basic Information',
            component: <SocialProfilesBasicInfoComponent
                handleInnerFormChange={handleInnerFormChange}
                selectedSocialProfiles={selectedSocialProfiles}
                socialProfileType={socialProfileType}
            />,
            isVisible: true,
        },

    ]
    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">


            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}

                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    );
}
export default SocialProfilesComponent;
